export default __webpack_public_path__ + "static/media/products.6384c0d3.png";